export default __webpack_public_path__ + "static/media/497.fa83abf2.png";